import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UsersPage } from './users';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  declarations: [
    UsersPage,
  ],
  imports: [
    NgxDatatableModule,
    IonicPageModule.forChild(UsersPage),
  ],
})
export class UsersPageModule {}



// WEBPACK FOOTER //
// ./src/pages/users/users.module.ts